import { useReducer } from 'react';
import { fetchReducer, FETCH_ACTION_TYPES, FetchState } from 'src/reducers/fetchReducer';
import { BenchmarkMatchResponse, benchmarkProductMatch } from 'src/api/matches';
import {
  useProductDetailsDispatchContext,
  useProductDetailsStateContext,
} from 'src/stateProviders/useProductDetailsStateContext';
import { PRODUCT_DETAILS_ACTION_TYPES, ProductDetailsState } from 'src/stateProviders/productDetailsStateProvider';
import { ResponseHeader } from 'src/types/ResponseHeader';
import ProductMatchInfo from 'src/types/ProductMatcheInfo';

const initialState: FetchState<ProductMatchInfo> = {
  loading: false,
  error: false,
  data: null,
};

export type DispatchRemoveMatch = {
  benchmarkMatch: (matchItems: ProductMatchInfo[]) => void;
};

const useMatchBenchmarkState = (): [FetchState<ResponseHeader>, DispatchRemoveMatch] => {
  const dispatchDetailsContext = useProductDetailsDispatchContext();
  const { productId } = useProductDetailsStateContext();
  const [state, dispatch] = useReducer(fetchReducer, initialState);

  return [
    state as FetchState<ResponseHeader>,
    {
      benchmarkMatch: async (matchItems: ProductMatchInfo[]) => {
        if (productId && matchItems) {
          const { canonicalId } = matchItems[0];
          const benchmarkMatch = '1';

          dispatch({ type: FETCH_ACTION_TYPES.loading, payload: { loading: true } });
          try {
            const response: BenchmarkMatchResponse = await benchmarkProductMatch(
              productId,
              [...matchItems.map((match) => match.productId)],
              canonicalId,
              benchmarkMatch
            );
            dispatch({ type: FETCH_ACTION_TYPES.setData, payload: { data: response.responseHeader } });
            dispatchDetailsContext({
              type: PRODUCT_DETAILS_ACTION_TYPES.benchmarkMatches,
              payload: { benchmarkedMatches: [...matchItems] } as ProductDetailsState,
            });
          } catch (e) {
            dispatch({ type: FETCH_ACTION_TYPES.setError, payload: { error: e } });
          }
        }
      },
    },
  ];
};

export default useMatchBenchmarkState;
